// @flow

import { type IncomingPayment } from './types';

export function isRetry(incomingPayment: IncomingPayment): boolean {
  if (incomingPayment.status !== 'OP')
    throw new Error(`IncomingPayment: there is no "retry" key in a "${incomingPayment.status} payment`);

  return !!incomingPayment.retry;
}
